import React, { useEffect, useState } from "react";
import layout from "../../assets/img/faq/questionaireBg.svg";
import "./FaqQuestionaire.css";

const FaqQuestionaire = () => {
  const [activeTab, setActiveTab] = useState("basics");
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [isCustomer, setIsCustomer] = useState("Basics");
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  const tabs = [
    { id: "basics", label: "Basics" },
    { id: "vehicle", label: "Vehicle and Property" },
    { id: "rental", label: "Rental/Transportation" },
    { id: "expense", label: "Expense" },
    { id: "mitigation", label: "Mitigation" },
    { id: "safety", label: "Driving Safety Tips" },
  ];

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  const faqContent = {
    basics: [
      {
        id: "accident",
        question: "What should I do if I have an accident?",
        // answer: "If you're involved in an accident: 1) Ensure everyone's safety and call emergency services if needed. 2) Exchange information with other parties involved. 3) Document the scene with photos. 4) Contact UAIC claims department at 1-800-XXX-XXXX. 5) Don't admit fault or discuss details with other parties."
        answer: `
        <p>Remain calm </br>
        If safe, move your vehicle out of traffic and turn on your hazard lights</br>
        Contact the police to report the loss</br>
        Get medical assistance if anyone is injured</br>
        Do not discuss or admit fault to anyone</br>
        Only discuss the loss with the police</br>
        Collect any information you can from the scene. This includes the insurance information, name, address, and phone number of anyone involved in the loss.</br>
        Seek out any witnesses before they leave the scene. Obtain their name, address, phone number, and any other method of contact.</br>
        Take photos of the accident scene and all vehicles involved. This would include skid marks, lights, lanes, intersections, and any other aspects of the scene.</br>
        Be sure to secure your vehicle from any further damage</br>
        If your vehicle is not drivable, move to a storage free facility.</br>
        Report the incident to United Automobile Insurance as soon as possible, using our online form.</br>
        </p>       
      `,
      },
      {
        id: "report",
        question: "How do I report a claim?",
        answer: `You have two options: <br/>
        <span style="text-indent:"2em">You can file a claim online 24 hours a day using this Link <a href="https://myclaim.uaig.net">https://myclaim.uaig.net!</a>
        You can report your claim via our toll-free number during regular business hours by calling (800) 344-2150</span>`,
      },
      {
        id: "info",
        question: "What information do I need to know to report a claim?",
        answer: `<p>
        United Automobile Insurance Company policy number, for example, UAU 000000000 <br/>
        Insurance information and phone number of anyone else involved in the accident with you <br/>
        Police report number and department name <br/>
        The date, time and place of the accident <br/>
        Knowledge of what happened in the loss <br/>
        Location of your vehicle</p>`,
      },
      {
        id: "status",
        question: "What is the status of my claim?",
        answer:
          "You can locate the status of your claim using our Web Portal. Provide directions here.",
      },
    ],
    vehicle: [
      {
        id: "damage",
        question: "How and when will my vehicle be inspected?",
        answer: `<p>After you file your claim, your vehicle's damage must be appraised. We offer several hassle-free options to meet your needs. Your options are: <br/>
        Drive-in estimate. Make an appointment with a network shop to get your estimate. <br/>
        Text or upload photos of your vehicle's damage. Click here for a template of the sample photos. <br/>
        In the event, your vehicle is not drivable and you are unable to submit photos, we will come to you.</p>`,
      },
      {
        id: "repairs",
        question:
          "What if more damage is found after the repairs have started?",
        answer: `<p>We write an initial estimate based on visible damages. However, new damages can be found once a repair facility commences the repair. In this case, the repair facility needs to call our supplement hotline and request a supplement. A supplement is a subsequent estimate of the new or additional damages found. If the vehicle is being repaired at one of our network shops, this is a seamless process. The network shops have a direct connection with us and the supplement will be done promptly and without additional delays.</p>`,
      },
      {
        id: "total-loss",
        question: "What if I don't have a repair shop?",
        answer: `<p>We have network of body shops in many areas that belong to our network of repair facilities. Furthermore, our network of repair facilities provide a guarantee on their repairs for as long as you own your vehicle.</p>`,
      },
    ],
    rental: [
      {
        id: "rental-coverage",
        question: "What if I am your insured and I need to rent a vehicle?",
        answer: `<p style="text-align:justify">The Florida Insurance Policy may provide Rental coverage if you opted to purchase it. Check your Declarations page to see if Rental Coverage appears there. The benefit is $20.00 per day up to $375.00 per policy term. If you have Comprehensive coverage and your vehicle was stolen, your policy includes transportation expenses. The benefit is $10.00 per day, to a maximum of 30 days. This coverage begins forty-eight (48) hours after the theft. Submit your paid rental invoice, from a legitimate car rental company to your adjuster to receive this benefit.
        <br/> <br/>
        The Texas Insurance Policy may provide Rental Reimbursement coverage if you opted to purchase it. Check your Declarations page to see if Rental Coverage appears there. The benefit has three options: $20.00, $30.00, or $40.00 per day up to 30 days. If you have Comprehensive coverage and your vehicle was stolen, your policy includes transportation expenses. The benefit is $20.00 per day, to a maximum of 30 days. This coverage begins forty-eight (48) hours after the theft. Submit your paid rental invoice, from a legitimate car rental company to your adjuster to receive this benefit.
        <br/> <br/>
        The Georgia Insurance Policy does not provide rental coverage for most losses. If you have Comprehensive coverage and your vehicle was stolen, your policy includes transportation expenses. The benefit is $20.00 per day, to a maximum of 30 days. This coverage begins forty-eight (48) hours after you report the theft to us. Submit your paid rental invoice, from a legitimate car rental company to your adjuster to receive this benefit.</p>`,
      },
      {
        id: "rental-process",
        question: "What if I am not your insured and I need to rent a vehicle?",
        answer: `<p>
         If your adjuster has cleared coverage and has determined liability in your favor, the adjuster may advise you that you are eligible for rental reimbursement of $25.00 per day; during the reasonable amount of time it will take to repair your vehicle.
 <br/> <br/>
<b>NOTE: The adjuster must authorize the rental in advance or you may not be eligible for reimbursement.</b>
 <br/> <br/>
No direct billing from a rental car company will be authorized. We work on a reimbursement basis only.<br/>
The shop of your choice should promptly order the parts outlined in our estimate as soon as your vehicle is dropped off. Please note it is possible for shops to pre-order parts.<br/>
Your vehicle should be delivered to the shop on a Monday or Tuesday, to avoid unnecessary weekend charges if your vehicle is drivable.<br/>
You should proactively communicate with the shop, to ensure repairs are proceeding according to schedule, and that we are immediately notified of any potential additional damages or charges.<br/>
You should promptly pickup your vehicle and return the insurance replacement rental vehicle upon completion of repairs.<br/>
Make sure to advise the rental company that you need an insurance replacement vehicle.<br/>
Collision damage waivers, additional liability coverages, gas, mileage, underage driver fees, or additional driver expenses will not be reimbursed.<br/>
You can obtain a rental through any legitimate car rental company of your choice. Please keep in mind that all rental expenses will be on a reimbursement basis for reasonable repair time only. Reasonable repair time is calculated using the repair hours on the estimate that we have provided, divided by 6 hours a day.<br/>
UAIC will not be responsible for any shop delays or any delays resulting from a failure to mitigate damages.<br/>
Upon completion of your vehicle's repair, you may text or mail your rental bill for consideration. However, if your vehicle is later deemed a total loss, reimbursement may not continue. Please include your claim number in any correspondence you send us.</p>`,
      },
      // {
      //   id: "transportation",
      //   question:
      //     "What if I don't have rental coverage but need transportation?",
      //   answer:
      //     "If you don't have rental coverage, you may still have options. Some repair facilities offer courtesy vehicles, or your claims representative can help you secure discounted rates with our rental partners. Public transportation costs may also be considered in certain circumstances. Contact your claims representative to discuss your specific situation.",
      // },
      // {
      //   id: "uber",
      //   question:
      //     "Will my insurance cover Uber or Lyft expenses while my car is being repaired?",
      //   answer:
      //     "Traditional rental reimbursement coverage typically doesn't extend to rideshare services like Uber or Lyft. However, UAIC offers alternative transportation coverage on some policies that may provide reimbursement for these services up to your policy limits. Check with your claims representative about your specific coverage options.",
      // },
    ],
    // expense: [
    //   {
    //     id: "covered-expenses",
    //     question: "What additional expenses are covered after an accident?",
    //     answer: `<p style="font-weight:bold">Depending on your policy, covered expenses may include:</p>
    //       <ul style="font-weight: normal">
    //       <li>1) Medical bills for injuries sustained</li>
    //       <li>2) Lost wages if you cannot work due to injuries</li>
    //       <li>3) Rental car costs</li>
    //       <li>4) Towing and storage fees</li>
    //       <li>5) Property damage replacement costs. Each coverage type has specific limits and conditions spelled out in your policy documents.</li>
    //       </ul>`,
    //   },
    //   {
    //     id: "medical",
    //     question: "How do medical expenses get paid after an accident?",
    //     answer:
    //       "If you have Medical Payments or Personal Injury Protection (PIP) coverage, UAIC will pay for covered medical expenses up to your policy limits regardless of fault. Submit all medical bills and records to your claims representative. For expenses exceeding your coverage, your health insurance may apply, or you may be compensated through a bodily injury claim if another party was at fault.",
    //   },
    //   {
    //     id: "reimbursement",
    //     question: "How do I get reimbursed for out-of-pocket expenses?",
    //     answer:
    //       "Keep detailed records and receipts for all accident-related expenses. Submit these to your claims representative along with a completed expense reimbursement form (available on our website or through your representative). Approved expenses will be reimbursed by check or direct deposit, typically within 7-10 business days after approval.",
    //   },
    //   {
    //     id: "lost-wages",
    //     question: "Can I get compensated for lost wages after an accident?",
    //     answer:
    //       "If you're unable to work due to accident-related injuries, you may be eligible for lost wage compensation. You'll need to provide documentation from your employer stating your regular wages and time missed, along with a doctor's note confirming you couldn't work. This coverage may be part of your PIP benefits or through a bodily injury claim, depending on your policy and the accident circumstances.",
    //   },
    // ],
    mitigation: [
      {
        id: "prevent-damage",
        question: "What is mitigation or legal duty to mitigate?",
        answer: `<p>
        The action of reducing the severity, seriousness, or painfulness of something. <br/>
        If your vehicle is accruing storage charges, you should immediately make arrangements to move it to a facility that will not charge you for storage. You will likely be requested to pay for the towing and storage charges incurred to date. Please be sure to save your receipt as we will reimburse you for reasonable charges provided that we accept coverage and liability. This also applies to temporary or emergency repairs to prevent further damage to your vehicle or property. We will require photographs of the damaged area, before its repair, along with a complete itemized estimate of repairs and a payment receipt.
        </p>`,
      },
      {
        id: "temporary-repairs",
        question: "What if I am your insured and my vehicle is at a tow yard?",
        answer:
          "If you are our insured, regardless of your Policy State, you must immediately release the vehicle to us and advise of its location. We will move the vehicle to a storage free facility and inspect your vehicle.",
      },
      {
        id: "mitigation-costs",
        question:
          "What if my vehicle is at a body shop and is declared a total loss?",
        answer:
          "If you are our insured, regardless of your Policy State, you must immediately release the vehicle to us and advise of its location. We will move the vehicle to a storage free facility and inspect your vehicle.",
      },
      {
        id: "neglect",
        question:
          "What if the vehicle is in danger of being towed from your residence?",
        answer:
          "If you are our insured, please contact us and make arrangements for the vehicle to be moved to a network shop or a storage free facility.",
      },
      {
        id: "neglect-1",
        question:
          "Do I need to mitigate damages if I do not have comprehensive and collision coverage?",
        answer:
          "Yes. Although you may not have coverage to repair or pay for your vehicle, you must minimize any further damages to your vehicle, so we may inspect the damages.",
      },
      {
        id: "neglect-2",
        question:
          "What if I am not your insured and my vehicle is at a tow yard?",
        answer: `<p>In Florida, if you are not insured with us, you must move your vehicle to a storage free facility for us to inspect the vehicle.
        <br/><br/>
        If the loss occurred in a State other than Florida, you must immediately release the vehicle to us and advise of its location. We will move the vehicle to a storage free facility and inspect your vehicle.</p>`,
      },
      {
        id: "neglect-3",
        question:
          "What if I am not your insured and my vehicle is at a tow yard?",
        answer: `<p>In Florida, if you are not insured with us, you must move your vehicle to a storage free facility for us to inspect the vehicle.
        <br/><br/>
        If the loss occurred in a State other than Florida, you must immediately release the vehicle to us and advise of its location. We will move the vehicle to a storage free facility and inspect your vehicle.</p>`,
      },
      {
        id: "neglect-4",
        question:
          "What if I am not your insured and my vehicle is at a body shop and declared a total loss?",
        answer: `<p>In Florida, if you are not insured with us, you must move your vehicle to a storage free facility for us to inspect the vehicle.
          <br/><br/>
          If the loss occurred in a State other than Florida, you must immediately release the vehicle to us and advise of its location. We will move the vehicle to a storage free facility and inspect your vehicle.</p>`,
      },
      {
        id: "neglect-5",
        question: "How do I mitigate damage to my property?",
        answer: `You should take pictures of the damage and submit 3 estimates for our review. If the structure has extensive damages that may exceed our insured's policy limit, please`,
      },
    ],
    safety: [
      {
        id: "defensive-driving",
        question: `Can you offer driving safety tips?`,
        answer: `<p>
        Don't drink and drive. <br/>
        Don't text and drive. <br/>
        Use hands-free devices if necessary. <br/>
        Use your turn signals. <br/>
        Respect yellow lights.<br/>
        Obey the speed limit.<br/>
        Make the appropriate adjustments for the weather.<br/>
        Speeding will not get you to your destination any faster.<br/>
        Always wear your seatbelt.<br/>
        Call for a ride if you are not feeling well.<br/>
        Pass safely on the left, never the right.<br/>
        In case of an accident or emergency pull completely off of the roadway if possible.<br/>
        Keep your eyes on the road and hands on the wheel.<br/>
        Be aware of your surroundings while driving.<br/>
        Green lights don't always mean go! Only enter the intersection if it is safe to do so.<br/>
        Keep your vehicle well maintained.<br/>
        Check the tire pressure regularly.<br/>
        Double-check any items being transported in a truck bed.<br/>
        Keep at least a 2-second gap between you and the car ahead of you.<br/>
        Never drive through high water.<br/>
        Reduce your speed in a construction zone.<br/>
        Move over and slow down for emergency vehicles.<br/>
        Turn on your headlights and wipers in the rain.<br/>
        Avoid driving while tired.<br/>
        Look before crossing railroad tracks.<br/>
        Allow plenty of time to get to your destination.</p>`,
      },
      // {
      //   id: "defensive-driving",
      //   question: "What are the key principles of defensive driving?",
      //   answer: `<p style="font-weight:bold">Key defensive driving principles include:</p>
      //     <ul style="font-weight: normal">
      //     <li>1) Stay alert and free from distractions</li>
      //     <li>2) Maintain a safe following distance (3-second rule)</li>
      //     <li>3) Anticipate hazards and other drivers' actions</li>
      //     <li>4) Be aware of blind spots</li>
      //     <li>5) Adjust driving for weather and road conditions</li>
      //     <li>6) Always have an escape route</li>
      //     <li>7) Avoid aggressive driving behaviors</li>
      //     <li>8) Never drive under the influence of alcohol or drugs.</li>
      //     </ul>`,
      // },
      // {
      //   id: "weather",
      //   question: "How should I adjust my driving in severe weather?",
      //   answer: `<p style="font-weight:bold">In severe weather:</p>
      //     <ul style="font-weight: normal">
      //     <li>1) Reduce speed appropriately</li>
      //     <li>2) Increase following distance</li>
      //     <li>3) Use headlights for visibility</li>
      //     <li>4) Avoid sudden braking or acceleration</li>
      //     <li>5) In heavy rain, avoid puddles and standing water</li>
      //     <li>6) In snow/ice, drive smoothly without abrupt movements</li>
      //     <li>7) Consider postponing travel in extreme conditions</li>
      //     <li>8) Ensure your vehicle is properly maintained with appropriate tires for the conditions.</li>
      //     </ul>`,
      // },
      // {
      //   id: "distracted",
      //   question: "How can I avoid distracted driving?",
      //   answer: `<p style="font-weight:bold">To avoid distracted driving:</p>
      //     <ul style="font-weight: normal">
      //     <li>1) Never text while driving</li>
      //     <li>2) Use hands-free systems for calls when necessary</li>
      //     <li>3) Set GPS and music before starting your journey</li>
      //     <li>4) Secure loose items that could roll around</li>
      //     <li>5) Don't eat complex foods while driving</li>
      //     <li>6) Pull over if you need to address children or pets</li>
      //     <li>7) Ask passengers to help with navigation or other tasks</li>
      //     <li>8) If tired, pull over and rest rather than continuing to drive.</li>
      //     </ul>`,
      // },
      // {
      //   id: "maintenance",
      //   question: "What regular vehicle maintenance helps prevent accidents?",
      //   answer: `<p style="font-weight:bold">Essential safety maintenance includes:</p>
      //     <ul style="font-weight: normal">
      //     <li>1) Regular brake inspections and service</li>
      //     <li>2) Maintaining proper tire pressure and tread depth</li>
      //     <li>3) Ensuring all lights and signals function properly</li>
      //     <li>4) Keeping windshield wipers in good condition</li>
      //     <li>5) Checking that mirrors are properly positioned</li>
      //     <li>6) Maintaining clean windows for visibility</li>
      //     <li>7) Following manufacturer's service schedule</li>
      //     <li>8) Addressing unusual noises or handling issues promptly.</li>
      //     </ul>`,
      // },
    ],
  };

  const toggleQuestion = (id) => {
    setActiveQuestion(activeQuestion === id ? null : id);
  };

  return (
    <div className="max-w-4xl mx-auto" style={{ marginTop: "-6em" }}>
      {/* Blue Header Background */}
      <div
        className="text-white px-6 py-12 rounded-t-lg text-center"
        style={
          responsiveStatus ? styles.leinHolderImage1 : styles.leinHolderImage
        }
      >
        <h2 className="text-h2">Claims FAQ</h2>
        <div
          style={{
            width: "120px",
            height: "2px",
            background: "#ffff",
            margin: "4px auto 0 auto",
          }}
        />

        <h1 className="" style={{ fontSize: "28px" }}>
          Do you have a question regarding a claim at UAIC?
        </h1>
        <p className="text-p">
          Here is a list of frequently asked questions that we receive from
          applicants. If you don't see your question <br /> or answer here,
          please contact us.
        </p>
      </div>

      <div
        className="container"
        style={{
          // marginTop: "-16em",
          position: "relative",
          zIndex: 10,
          maxWidth: "1350px",
          margin: responsiveStatus ? "0 auto" : "0 auto",
          // top: responsiveStatus ? "-3em" : "-6em",
          // marginBottom: "-18em",
        }}
      ></div>
      <div
        className="mx-auto border rounded shadow p-4 "
        style={{ maxWidth: "auto", backgroundColor: "#F7F7FB" }}
      >
        {/* Tabs */}
        <div
          className="border-bottom mb-3 overflow-auto"
          style={{
            display: "flex",
            flexWrap: "nowrap",
            gap: "0.5rem",
            scrollbarWidth: "thin", // Firefox
          }}
        >
          {[
            { label: "Basics", tab: "basics" },
            { label: "Vehicle and Property", tab: "vehicle" },
            { label: "Rental/Transportation", tab: "rental" },
            // { label: "Expense", tab: "expense" },
            { label: "Mitigation", tab: "mitigation" },
            { label: "Driving Safety Tips", tab: "safety" },
          ].map(({ label, tab }) => (
            <button
              key={label}
              className={`btn flex-shrink-0 ${
                isCustomer === label ? "fw-bold text-blue" : "text-muted-color"
              }`}
              style={{
                borderRadius: 0,
                borderBottom:
                  isCustomer === label ? "2px solid #0e72d6" : "none",
                whiteSpace: "nowrap", // prevent text wrap
              }}
              onClick={() => {
                setIsCustomer(label);
                setActiveTab(tab);
              }}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="tab-content" id="faqTabsContent">
          {tabs.map((tab) => (
            <div
              className={`tab-pane fade ${
                activeTab === tab.id ? "show active" : ""
              }`}
              id={tab.id}
              role="tabpanel"
              aria-labelledby={`${tab.id}-tab`}
              key={tab.id}
            >
              <div className="accordion mt-3" id={`accordion-${tab.id}`}>
                {faqContent[tab.id]?.map((faq, idx) => (
                  <div className="accordion-item" key={faq.id}>
                    <h2 className="accordion-header" id={`heading-${faq.id}`}>
                      <button
                        className={`accordion-button ${
                          activeQuestion === faq.id ? "" : "collapsed"
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${faq.id}`}
                        aria-expanded={activeQuestion === faq.id}
                        aria-controls={`collapse-${faq.id}`}
                        onClick={() => toggleQuestion(faq.id)}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse-${faq.id}`}
                      className={`accordion-collapse collapse ${
                        activeQuestion === faq.id ? "show" : ""
                      }`}
                      aria-labelledby={`heading-${faq.id}`}
                      data-bs-parent={`#accordion-${tab.id}`}
                    >
                      <div
                        className="accordion-body"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />

                      {/* {faq.answer} */}
                      {/* </div> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* {isCustomer == 'Vehicle and Property' && (
          <>
            <p className="text-secondary text-left">
              2
            </p>
            </>
)}
{isCustomer == 'Rental/Transportation' && (
          <>
            <p className="text-secondary text-left">
              3
            </p>
            </>
)}
{isCustomer == 'Expense' && (
          <>
            <p className="text-secondary text-left">
              4
            </p>
            </>
)}
{isCustomer == 'Mitigation' && (
          <>
            <p className="text-secondary text-left">
              5
            </p>
            </>
)}
{isCustomer == 'Driving Safety Tips' && (
          <>
            <p className="text-secondary text-left">
              6
            </p>
            </>
)} */}
      </div>
    </div>
  );
};
const styles = {
  leinHolderImage: {
    minHeight: "30vh",
    overflow: "hidden",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    cursor: "text",
  },
  leinHolderImage1: {
    minHeight: "30vh",
    overflow: "hidden",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    cursor: "text",
  },
};

export default FaqQuestionaire;
